/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_User_Setup_IncompleteInputs */



/**
* | output |
* | --- |
* | "User setup is incomplete. Please complete the setup process." |
*
* @param {Auth_User_Setup_IncompleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_user_setup_incomplete = /** @type {((inputs?: Auth_User_Setup_IncompleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_User_Setup_IncompleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer-Einrichtung unvollständig. Bitte kontaktiere den Administrator.")
	return /** @type {LocalizedString} */ ("User setup is incomplete. Please complete the setup process.")
});